import './profile-vortex.css';

interface ProfileVortexProps {
  driver: {
    photoUrl?: string;
    displayName: string;
    status: 'active' | 'inactive' | 'driving';
  };
}

export function ProfileVortex({ driver }: ProfileVortexProps) {
  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <div className="profile-vortex">
      {/* Portal depth effect - concentric gradient rings */}
      <div className="profile-vortex__depth" aria-hidden="true">
        <div className="profile-vortex__ring profile-vortex__ring--outer" />
        <div className="profile-vortex__ring profile-vortex__ring--middle" />
        <div className="profile-vortex__ring profile-vortex__ring--inner" />
      </div>

      {/* Simple elegant photo frame */}
      <div className="profile-vortex__photo-frame">
        {driver.photoUrl ? (
          <img src={driver.photoUrl} alt={driver.displayName} />
        ) : (
          <div className="profile-vortex__placeholder">
            {getInitials(driver.displayName)}
          </div>
        )}

        {/* Status LED */}
        <div className={`profile-vortex__status-led profile-vortex__status-led--${driver.status}`} />
      </div>

      {/* Emergence glow */}
      <div className="profile-vortex__glow" aria-hidden="true" />
    </div>
  );
}
